import { createContext, useContext } from 'react';

export const GtmCtx = createContext<{
  isInitialized: boolean;
}>({ isInitialized: false });

export function useGtmContext() {
  return useContext(GtmCtx);
}
